import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { MasterDataResponse, ErrorInterface, MasterDataState } from '../model/masterData.model'

export interface MasterDataRequest {
  dealerId: string
  subscriptionType: string
}

export const initialState: MasterDataState = {
  loading: null,
  errorCode: '',
  errorMessage: '',
  data: {
    nationalities: [],
    segments: [],
  },
}

export const locationsSlice = createSlice({
  name: 'masterData',
  initialState,
  reducers: {
    fetchMasterData: (_state, _action: PayloadAction<MasterDataRequest>) => ({
      ...initialState,
      loading: true,
    }),
    fetchMasterDataSuccess: (state, action: PayloadAction<MasterDataResponse>) => ({
      ...initialState,
      data: action.payload,
      loading: false,
    }),
    fetchMasterDataError: (state, action: PayloadAction<ErrorInterface>) => {
      const {
        payload: { errorMessage, errorCode },
      } = action
      return {
        ...initialState,
        loading: false,
        errorCode,
        errorMessage,
      }
    },
    resetMasterData: () => initialState,
  },
})

export const {
  fetchMasterData,
  fetchMasterDataSuccess,
  fetchMasterDataError,
  resetMasterData,
} = locationsSlice.actions

const locationsReducer = locationsSlice.reducer
export default locationsReducer
